import Player from '@vimeo/player';
import YTPlayer from 'yt-player';

export default {
  init($element) {
  },
  finalize($element) {
    const videoDivId = $element.find('.full-width-video').prop('id');
    const videoId = $element.find('.full-width-video').data('vid-id');
    const $splashWrap = $element.find('.video-splash');

    if ($element.find('.full-width-video').data('type') == 'vimeo') {
      // vimeo player
      const vimeoPlayer = new Player(videoDivId, {
        id: videoId,
      });

      $splashWrap.find('.video-splash-play').on('click', function() {
        $splashWrap.hide();
        vimeoPlayer.play();
      });
      
      vimeoPlayer.on('ended', function() {
        $splashWrap.show();
      });
    } else {
      // youtube player
      const ytPlayer = new YTPlayer(`#${videoDivId}`);
      ytPlayer.load(videoId);

      $splashWrap.find('.video-splash-play').on('click', function() {
        $splashWrap.hide();
        ytPlayer.play();
      });

      ytPlayer.on('ended', () => {
        $splashWrap.show();
      });
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/partials/general/fullWidthVideo.js